module.exports = __webpack_public_path__ + "img/51626495_L.ea17cc8c.png";